<template>
    <!-- popup -->
    <div class="menu">
      <div v-if="iconData.type === 'champion'" class="skill-box">
        <div>spells</div>
        <div class="sub-icon">
          <draggable-icon :icon="getIconById(iconData.passive)" />
        </div>
        <div class="sub-icon"  v-for="spell in iconData.spells" :key="spell">
          <draggable-icon :icon="getIconById(spell)" />
        </div>
      </div>

      <div>
        <div>items</div>
      </div>

      <div class="edit">
        <!-- label edit -->
        <div>
          Enter label string
          <el-input
            v-model="label"
          />

          <!-- range size edit -->
          range size
          <el-slider
            v-model="range"
            @change="updateObjectProperty({range: $event, id: icon.id})"
            :max="300"
          />
        </div>

        <!-- border color edit -->
        <div>
          <el-color-picker
            v-model        ="borderColor"
            :predefine     ="predefineColors"
            @active-change ="updateObjectProperty({borderColor: $event, id: icon.id})"
            show-alpha
          />

          <!-- scale edit -->
          <el-slider
            v-model="scale"
            @change="updateObjectProperty({scale: $event, id: icon.id})"
            :max="500"
          />
        </div>
      </div>

      <div>
        <el-button @click="close">close</el-button>
        <el-button @click="removeButton">remove</el-button>
      </div>
    </div>
</template>

<script lang="">
import { mapActions, mapGetters } from 'vuex'
import DraggableIcon from './draggable-icon'

export default {
  // Options / Data
  data () {
    return {
      scaleModel      : 100,
      predefineColors : [
        'rgba(218,179,0,1)',
        'rgba(255,0,0,1)',
        'rgba(0,255,0,1)',
        'rgba(0,0,255,1)'
      ]
    }
  },
  props    : [ 'data' ],
  computed : {
    icon () { return this.data.icon },
    iconData () {
      return this.getIconById(this.icon.iconId)
    },
    label: {
      get () { return this.icon.label },
      set (value) {
        this.updateObjectProperty({
          id    : this.icon.id,
          label : value
        })
      }
    },
    range: {
      get () { return this.icon.range },
      set (value) {
        this.updateObjectProperty_local({
          id    : this.icon.id,
          range : value
        })
      }
    },
    scale: {
      get () { return this.icon.scale },
      set (value) {
        this.updateObjectProperty_local({
          id    : this.icon.id,
          scale : value
        })
      }
    },
    borderColor: {
      get () { return this.icon.borderColor },
      set (value) {}
    },
    ...mapGetters('object/icon', [
      'getIconById'
    ])
  },
  methods: {
    removeButton () {
      this.removeObject(this.icon.id)
      this.$emit('close')
    },
    colorPickerChange (value) {
      this.updateObjectProperty({
        id          : this.icon.id,
        borderColor : value
      })
    },
    close () {
      this.$emit('close')
    },
    ...mapActions('object', [
      'removeObject',
      'updateObjectProperty',
      'updateObjectProperty_local'
    ])
  },
  components: {
    DraggableIcon
  }
  // watch: {},
  // Options / DOM
  // el () {},
  // replace: true,
  // template: '',
  // Options / Lifecycle Hooks
  // init () {},
  // crated () {},
  // beforeCompile () {},
  // compiled () {},
  // ready () {},
  // attached () {},
  // detached () {},
  // beforeDestroy () {},
  // destroyed () {},
  // Options / Assets
  // directives: {},
  // elementDirectives: {},
  // filters: {},
  // components: {},
  // transitions: {},
  // partials: {},
  // Options / Misc
  // parent: null,
  // events: {},
  // mixins: [],
}
</script>

<style scoped>
.menu {
  width: 300px;
}

.edit {
  padding: 20px;
}

.sub-icon {
  display  : inline-block;
  position : relative;
}
.slill-box img {
  width  : 40px;
  height : auto;
}

.skill-box {
  margin           : auto;
  width            : 230px;
  background-color : white;
}
</style>



// WEBPACK FOOTER //
// src/components/popup-window/icon.vue